import React from "react";
import { Helmet } from "react-helmet";

export const TermsAndConditions = () => {
  return (
    <>
      <Helmet>
        <title>
          Popular RKS True Value Terms and Conditions: Your Guide to a Hassle-Free
          Experience
        </title>
        <meta
          name="title"
          content="Popular RKS True Value Terms and Conditions: Your Guide to a Hassle-Free Experience"
        />
        <meta
          name="description"
          content="Before purchasing a pre-owned car from True Value, it's essential to understand the terms and conditions to ensure a smooth and transparent transaction. From warranty details to return policies, this guide provides clarity on what to expect when buying a used car from True Value."
        />
        <meta
          name="keywords"
          content="Popular RKS True Value, terms and conditions, pre-owned cars, warranty, return policy, used car dealership, transparent transaction, hassle-free experience
"
        />
      </Helmet>
      <img
        src={require("../../assets/other/Cars-range.webp")}
        alt="Privacy Policy"
      />
      <div className="px-1 pt-5 pb-10">
        <h1 className="mt-4 mb-8 text-3xl font-bold text-center lg:text-4xl text-primary lg:whitespace-nowrap">
          Privacy Policy
        </h1>
        <div className="container mx-auto md:text-lg">
          <p>Popular RKS Maruti Suzuki Statement Of Privacy</p>
          <p className="pb-4 lg:pb-8">
            At Popular RKS we take your privacy seriously. Please read the
            following to learn more about our terms and conditions.
          </p>
          <p className="py-2">What The Terms And Conditions Cover</p>
          <p className="pb-4 lg:pb-8">
            This covers Popular RKS Maruti Suzuki treatment of personally
            identifiable information that Popular RKS Maruti Suzuki collects when
            you are on Popular RKS Maruti Suzuki site and when you use our
            services. This policy also covers Popular RKS Maruti Suzuki treatment
            of any Personally identifiable information that Popular RKS Maruti
            Suzuki shares with you. This policy does not apply to the practices
            of companies that Popular RKS Maruti Suzuki does not own or control or
            Popular RKS Maruti Suzuki does not own or employ or manage.
          </p>
          <p className="py-2">Information Collection And Use</p>
          <p className="py-2">
            Popular RKS Maruti Suzuki collects personally identifiable information
            when you register for a Popular RKS Maruti Suzuki account. When you
            choose the services and promotions. Popular RKS Maruti Suzuki may also
            receive personally identifiable information from our business
            partners.
          </p>
          <p className="pb-4 lg:pb-8">
            When you register with Popular RKS Maruti Suzuki, we ask for your
            name, e-mail address, birth date, gender, occupation, industry and
            personal interest. Once you register with Popular RKS Maruti Suzuki
            and sign in to our services, you are not anonymous to us. Popular RKS
            Maruti Suzuki uses information for three general purpose: to fulfill
            your requests for certain products and services and to contact you
            about specials and new products.
          </p>
          <p className="py-2">Information Sharing And Disclosure</p>
          <p className="py-2">
            Popular RKS Maruti Suzuki will not sell or rent your Personally
            Identifiable Information to anyone.
          </p>
          <p className="py-2">
            Popular RKS Maruti Suzuki will send Personally Identifiable
            Information about you when:
          </p>
          <ul className="pb-4 pl-5 space-y-2 list-disc">
            <li>We have your consent to share the information.</li>
            <li>
              We need to share your information to provide the product or
              service you have requested.
            </li>
            <li>We respond to subpoenas, court orders or legal process.</li>
            <li>
              We need to send the information to companies who work on behalf of
              Popular RKS Maruti Suzuki to provide a product or service to you.
              Unless we tell you differently, these companies do not have any
              right to use the Personally Identifiable Information we provide to
              them beyond what is necessary to assist us.
            </li>

            <li>
              We respond to subpoenas, court orders or legal process; or we find
              that your actions on our web sites violate the Popular RKS Maruti
              Suzuki Terms of Service or any of our usage guidelines for
              specific products or services.
            </li>
          </ul>
          <p className="py-2">Security</p>
          <p className="pb-4 lg:pb-8">
            Your Popular RKS Maruti Suzuki account information is
            password-protected for your privacy and security We have taken
            adequate measures to secure access to your personal data
          </p>
          <p className="py-2">Changes To This Policy</p>
          <p className="pb-4 lg:pb-8">
           Popular RKS Maruti Suzuki may edit this policy from time to time. If
            we make any substantial changes ,we will notify you by posting a
            prominent announcement on our pages.
          </p>
        </div>
      </div>
    </>
  );
};
